module.exports = __webpack_public_path__ + "static/2-2fbdd31e4419abf19cf0579f5ce2f824.jpg";